'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('../adjudicators/paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id) {
  return function (dispatch, getState) {

    var adjIds = (0, _paths.getEventAdjudicatorIds)(getState(), feis_id, event_id);
    if (adjIds) return;

    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/events/' + event_id + '/adjudicators'
      },
      types: ['GET_EVENT_ADJUDICATORS_START', 'GET_EVENT_ADJUDICATORS', 'GET_EVENT_ADJUDICATORS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getAdjudicatorsForEvent.js
// module id = 153
// module chunks = 0